import { useCallback, useContext, useEffect, useState } from 'react';

import { Tabs } from '@hdi-seguros/web-components.tabs';
import { FormCoverages } from './components/Form';
import { StepThreeFormContext } from '../../../../../StepThree/contexts';
import { ColSize, RowSize } from '../../../../../../../../../../../shared/components';

export const PropertyDataSection = () => {
  const { quotationResponse } = useContext( StepThreeFormContext );

  const [activeTab, setActiveTab] = useState<any>(quotationResponse?.componentes[0].nroDeComponente);
  const [tabs, setTabs] = useState<Array<any>>([]);

  const createTabs = useCallback(() => {
    const newTabs = quotationResponse?.componentes?.map((theftInsuranceComponent, index: number) => ({
      children: (
        <FormCoverages 
          key={`${theftInsuranceComponent.codigoPostal}-${index}`}
          theftInsuranceComponent={theftInsuranceComponent} 
        />
      ),
      closable: false,
      forceRender: true,
      key: theftInsuranceComponent.nroDeComponente,
      label: `Robo ${theftInsuranceComponent.nroDeComponente}`,
    }));

    setTabs(newTabs ?? []);
  }, [quotationResponse, setTabs]);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <RowSize className='mt-1'>
      <ColSize size={100}>
        <Tabs
          activeKey={activeTab}
          handlePressTab={handlePressTab}
          items={tabs}
        />
      </ColSize>
    </RowSize>
  );
};
